import React from "react";
import { Rating, ReviewsList } from "./";
import { GoogleReview } from "./../../models";
import classNames from "classnames";

interface Props {
  reviews: GoogleReview[];
  ratingValue: number;
}
interface State {
  isExpanded: boolean;
}

class GoogleReviews extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false
    };
  }
  handleClick = () => {
    this.setState({
      isExpanded: true
    });
  };
  render() {
    const { reviews, ratingValue } = this.props;
    const reviewsClass = classNames({
      "google-reviews": true,
      "is-expanded": this.state.isExpanded
    });
    return (
      <div className={reviewsClass}>
        <Rating isLarge={true} ratingValue={ratingValue} />
        <ReviewsList reviews={reviews} />
        <button onClick={this.handleClick} className="btn btn-primary btn-view-all-reviews">
          Show more reviews
        </button>
      </div>
    );
  }
}

export default GoogleReviews;
